export default "__VITE_ASSET__Bgt_asRd__"